export const en = {
    'error-refresh': 'An error has occurred. Try refreshing the page.',
    'no-rights': 'No rights to view recommendations'
};
